module.exports = __webpack_public_path__ + "static/ACC-logo-34c8a8085311f84d0796bac428daa216.jpg";